/**
 *  @function SearchFallback
 *
 *  The storefront search matches fewer products than the predictive search API
 *  (no prefix matching, no tag matching). When the main search results fit on
 *  a single page, this asks the predictive search API for the same terms and
 *  appends any products that are not already in the grid, using the exact same
 *  product-card markup (rendered by sections/predictive-search-fallback.liquid).
 *
 *  It only runs on unfiltered, unsorted, unpaginated result sets so filtering,
 *  sorting and pagination keep operating on the real search results. The
 *  predictive search drawer is untouched.
 */
(function () {
  'use strict';

  var SECTION_ID = 'predictive-search-fallback';
  var FIELDS = 'title,product_type,vendor,variants.title,variants.sku,tag';
  var LIMIT = 10;

  function getSearchParams() {
    return new URLSearchParams(window.location.search);
  }

  function shouldRun(grid, params) {
    if (params.get('sort_by')) {
      return false;
    }
    if (params.get('page') && params.get('page') !== '1') {
      return false;
    }
    var type = params.get('type');
    if (type && type.indexOf('product') === -1) {
      return false;
    }
    var hasFilter = false;
    params.forEach(function (value, key) {
      if (key.indexOf('filter.') === 0) {
        hasFilter = true;
      }
    });
    if (hasFilter) {
      return false;
    }
    var resultsCount = parseInt(grid.dataset.resultsCount, 10) || 0;
    var perPage = parseInt(grid.dataset.perPage, 10) || 0;
    if (perPage && resultsCount >= perPage) {
      return false;
    }
    return true;
  }

  function renderCounts(doc, count) {
    var suffix = count === 1 ? 'One' : 'Other';
    var countTemplate = doc.getElementById('PredictiveFallbackCount' + suffix);
    var foundTemplate = doc.getElementById('PredictiveFallbackFound' + suffix);
    var labels = document.querySelectorAll('.thb-filter-count .facets__label');
    var banner = document.querySelector('.search-results-found-count');

    if (countTemplate) {
      var countText = countTemplate.innerHTML.replace('999999', count);
      labels.forEach(function (label) {
        label.textContent = countText;
      });
    }
    if (foundTemplate && banner) {
      banner.textContent = foundTemplate.innerHTML.replace('999999', count);
    }
  }

  function init() {
    var grid = document.querySelector('[data-search-fallback]');
    if (!grid) {
      return;
    }
    var params = getSearchParams();
    if (!shouldRun(grid, params)) {
      return;
    }
    var terms = (grid.dataset.searchTerms || params.get('q') || '').trim();
    if (!terms) {
      return;
    }
    var root = (window.theme && theme.routes && theme.routes.predictive_search_url) || '/search/suggest';
    var url = root + '?q=' + encodeURIComponent(terms) + '&' + encodeURIComponent('resources[type]') + '=product&' + encodeURIComponent('resources[limit]') + '=' + LIMIT + '&resources[options][fields]=' + FIELDS + '&section_id=' + SECTION_ID;

    fetch(url)
      .then(function (response) {
        return response.ok ? response.text() : '';
      })
      .then(function (text) {
        if (!text) {
          return;
        }
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var results = doc.getElementById('PredictiveFallbackResults');
        if (!results) {
          return;
        }
        var existing = {};
        grid.querySelectorAll('[data-product-handle]').forEach(function (item) {
          existing[item.dataset.productHandle] = true;
        });

        var added = 0;
        results.querySelectorAll('li[data-product-handle]').forEach(function (item) {
          if (existing[item.dataset.productHandle]) {
            return;
          }
          existing[item.dataset.productHandle] = true;
          grid.appendChild(item);
          added++;
        });
        if (!added) {
          return;
        }
        grid.removeAttribute('hidden');
        var empty = document.querySelector('[data-search-fallback-empty]');
        if (empty) {
          empty.style.display = 'none';
        }
        var resultsCount = parseInt(grid.dataset.resultsCount, 10) || 0;
        renderCounts(doc, resultsCount + added);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
